export function isAuthenticatedRoute(pathname) {
  let isLoginRoute,
    isResetPasswordRoute,
    isForgotPasswordRoute,
    isChangePasswordRoute,
    isUpdateAccountRoute

  isLoginRoute = pathname.indexOf('/login') > -1
  isResetPasswordRoute = pathname.indexOf('/resetpassword') > -1
  isForgotPasswordRoute = pathname.indexOf('/forgotpassword') > -1
  isChangePasswordRoute = pathname.indexOf('/changepassword') > -1
  isUpdateAccountRoute = pathname.indexOf('/unlockaccount') > -1

  return (
    !isResetPasswordRoute &&
    !isForgotPasswordRoute &&
    !isLoginRoute &&
    !isChangePasswordRoute &&
    !isUpdateAccountRoute
  )
}

export function isFullWidthRoute(pathname) {
  return pathname.indexOf('/mycourses') > -1
}

export function allowAccessToRoute(user, route) {
  if (route === 'mycourses') {
    return user.organization_roles.some(role => role === 'qm_mentor_author')
  }

  if (route === 'myquests' || route === 'quests/add') {
    return user.organization_roles.some(
      role => role === 'qm_editor' || role === 'qm_quest_manager'
    )
  }

  if (route === 'queue') {
    return user.organization_roles.some(
      role =>
        role === 'qm_internal_review' ||
        role === 'qm_copy_editor' ||
        role === 'qm_quest_manager'
    )
  }

  if (route === 'reviewqueue') {
    return user.organization_roles.some(role => role === 'qm_platform_review')
  }

  if (
    route === 'quests' ||
    route === 'productionstatus' ||
    route === 'topicclouds'
  ) {
    return !user.organization_roles.some(role => role === 'qm_mentor_author')
  }

  return false
}

export function getDefaultRoute(orgRoles) {
  let route = ''
  if (orgRoles.indexOf('qm_editor') > -1) {
    route = '/myquests'
  } else if (orgRoles.indexOf('qm_platform_review') > -1) {
    route = '/reviewqueue'
  } else if (
    orgRoles.indexOf('qm_internal_review') > -1 ||
    orgRoles.indexOf('qm_copy_editor') > -1 ||
    orgRoles.indexOf('qm_quest_manager') > -1
  ) {
    route = '/queue'
  } else if (orgRoles.indexOf('qm_mentor_author') > -1) {
    route = '/mycourses'
  } else {
    route = '/quests'
  }

  return route
}



// WEBPACK FOOTER //
// ./src/utils/routes.js